// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { warehouseStaffRoute, warehouseStaffRouteAbsolute } from '../roleRoutes/warehouseStaff';
// Styles, images, icons
import { icons } from '~/assets';

export const privateWarehouseStaffRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: warehouseStaffRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: warehouseStaffRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: warehouseStaffRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: warehouseStaffRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: warehouseStaffRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: warehouseStaffRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}${warehouseStaffRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: warehouseStaffRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}${warehouseStaffRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: warehouseStaffRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: warehouseStaffRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.jobs}${warehouseStaffRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: warehouseStaffRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: warehouseStaffRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: warehouseStaffRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: warehouseStaffRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: warehouseStaffRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.order}${warehouseStaffRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.order}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: warehouseStaffRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: warehouseStaffRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.invoice}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}${warehouseStaffRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: warehouseStaffRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: warehouseStaffRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: warehouseStaffRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: warehouseStaffRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: warehouseStaffRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}${warehouseStaffRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: warehouseStaffRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: warehouseStaffRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: warehouseStaffRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: warehouseStaffRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: warehouseStaffRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: warehouseStaffRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: warehouseStaffRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: warehouseStaffRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.purchaseOrder}${warehouseStaffRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: warehouseStaffRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: warehouseStaffRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}${warehouseStaffRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: warehouseStaffRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: warehouseStaffRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}${warehouseStaffRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: warehouseStaffRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: warehouseStaffRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: warehouseStaffRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.roleManagement}${warehouseStaffRoute.commonDetail}${warehouseStaffRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: warehouseStaffRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: warehouseStaffRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: warehouseStaffRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: warehouseStaffRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
